const github_link = "https://github.com/ajoy10";
const linkedin_link = "https://www.linkedin.com/in/ajoy-ajayan";
const hacker_rank_link = "https://www.hackerrank.com/ajoy10";

module.exports = { github_link, linkedin_link, hacker_rank_link };
